import {Pipe, PipeTransform} from '@angular/core';
import {isNaN} from 'lodash';

@Pipe({name: "value_by_key"})
export class ValueByKeyPipe implements PipeTransform {

    transform(key: any, array: Array<any> = []): string {
        try {
            key = parseInt(key);
            if (isNaN(key)) {
                return '';
            }
            let item: any = array.find(item => item.id === key);
            return (item) ? item.name : `${key}`
        } catch (e) {
            return ''
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/core/pipes/value.by.key.pipe.ts